import CryptoJS from "crypto-js";
import { authorization } from "module/auth";
import CONFIG from "config/config";

const encrypt = (str) => CryptoJS.AES.encrypt(str, CONFIG.CRYPTO_SECRET_KEY).toString();

const decrypt = (encrypted) => {
  const decrypted = CryptoJS.AES.decrypt(encrypted, CONFIG.CRYPTO_SECRET_KEY);
  return decrypted.toString(CryptoJS.enc.Utf8);
};

const authorize = () => {
  const url = new URL(window.location.href);

  const cryptedApiKey = url.searchParams.get("key");
  const cryptedUser = url.searchParams.get("user");
  const source = url.searchParams.get("source");

  if (cryptedApiKey && cryptedUser) {
    const apiKey = decrypt(cryptedApiKey);
    const user = JSON.parse(decrypt(cryptedUser));
    const createdFromAudiencesPage = source === "audiences";

    authorization.login(user, apiKey);
    // preserve all query params except key and user
    const queryParams = new URLSearchParams(url.search);
    queryParams.delete("key");
    queryParams.delete("user");
    if (createdFromAudiencesPage) {
      queryParams.set("source", "audiences");
    }
    window.location.replace(
      `${url.origin}${url.pathname}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
    );
  }
};

export { authorize, decrypt, encrypt };
